import { Link } from '~/components/Link'

import EncyclopediaIcon from '~/bootcamp/components/EncyclopediaIcon'

import { CATEGORY_COLORS } from '~/bootcamp/constants/bootcamp.const'
import SVGImage from '~/components/Image/SVGImage'
import { TopicId, getPathGradientColors } from '~/dashboard/utils/learningPath.utils'

interface Props {
  isCompleted: boolean
  levelTitle: string
  topic: TopicId
  path: string
  onClick: (title: string) => void
}

export default function EncyclopediaLevel({
  levelTitle,
  isCompleted,
  topic,
  path,
  onClick,
}: Props): React.ReactElement {
  const color = getPathGradientColors(topic as TopicId)
  const borderColorClass = CATEGORY_COLORS[topic]?.borderClass

  return (
    <Link className={`w-full ${isCompleted ? 'pt-3.5' : ''}`} onClick={() => onClick(levelTitle)} to={path}>
      {isCompleted ? (
        <div className="mx-auto relative flex items-center rounded p-2.5 h-fit border-white border bg-purple-darker text-white">
          <SVGImage className="min-w-12" height={34} srcKey="bootcamp/checkmark-white-border.svg" width={34} />
          <div className="absolute -top-4.5 -left-5">
            <EncyclopediaIcon className="relative w-10" color={color} id={topic} size="small" />
          </div>
          <p className="text-base tracking-px">{levelTitle}</p>
        </div>
      ) : (
        <div
          className={`mx-auto flex space-x-2.5 items-center border-4 rounded p-1 bg-white h-fit ${borderColorClass}`}
        >
          <EncyclopediaIcon className="relative w-11" color={color} id={topic} size="small" />
          <p className="text-base tracking-px py-1.5">{levelTitle}</p>
        </div>
      )}
    </Link>
  )
}
